import { RefCallback, useRef, useState } from "react";
import { A11Y_DEFAULT_CURRENT_INDEX } from "./constants";

export const useA11yChildren = () => {
  const [a11yCurrentChildIndex, setA11yCurrentChildIndex] = useState(
    A11Y_DEFAULT_CURRENT_INDEX
  );

  const a11yChildRefs = useRef<Array<HTMLElement>>([]);

  const setA11yChildRefs =
    (index: number): RefCallback<HTMLElement> =>
    (node) => {
      if (node === null) {
        return;
      }

      a11yChildRefs.current[index] = node;
    };

  return {
    a11yCurrentChildIndex,
    a11yChildRefs,
    setA11yCurrentChildIndex,
    setA11yChildRefs,
  };
};
